import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { catchError, first, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { isEmpty } from 'lodash';

import { selectCompanyProfile } from 'projects/workspace/src/app/administration/store/selectors';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';
import { AdministrationsApiService } from 'projects/workspace/src/app/administration/services/administrations-api.service';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { SbcPermissionEnum } from 'projects/workspace/src/app/administration/enums/sbc-permission.enum';
import { SubscriptionPlanEnum } from 'common/src/modules/subscription-activation/subscription-activation.emum';
import { UpgradePlanModalComponent } from 'common/src/modules/modals/modals-common';

@Injectable({
  providedIn: 'root'
})
export class UsersFreePlanGuard implements CanActivate {

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private readonly administrationsApiService: AdministrationsApiService,
    private readonly store: Store<AppState>
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.store.select(selectCompanyProfile).pipe(
      first(),
      switchMap((companyProfile: CompanyProfile) => {
        return isEmpty(companyProfile) ? this.administrationsApiService.getCompanyProfile() : of(companyProfile);
      }),
      catchError(() => {
        return of(false);
      }),
      switchMap((companyProfile: CompanyProfile) => {
        if (companyProfile.subscriptionManagement.subscriptionPlanActive !== SubscriptionPlanEnum.FREE) {
          return of(true);
        } else {
          this.dialog.open(UpgradePlanModalComponent, { data: {
              validationFeature: SbcPermissionEnum.TEAM_USERS,
              forwardUrl: state.url
            }});
          return of(false);
        }
      }),
    );
  }
}
